import React, {useState, useMemo} from 'react'
import {Box, Flex, useMultiStyleConfig, Button} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import YearSelect from './year-select'
import ChevronLeft from '../../icons/shared/arrows/ChevronLeft'
import ChevronRight from '../../icons/shared/arrows/ChevronRight'
import {useIntl} from 'react-intl'

const DatePickerHeader = ({
    date,
    changeYear,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
    locale,
}) => {
    const currentYear = date.getFullYear()
    const years = useMemo(
        () => Array.from({length: 100}, (_, i) => new Date().getFullYear() - i),
        [],
    )
    const monthLabel = date.toLocaleDateString(locale || 'en-GB', {month: 'long', year: 'numeric'})
    const styles = useMultiStyleConfig('DatePicker', {})
    const [lastClicked, setLastClicked] = useState('prev')

    const {formatMessage} = useIntl()

    return (
        <Box {...styles?.headerContainer}>
            <Flex {...styles?.monthControllsContainer}>
                <Button
                    onClick={() => {
                        setLastClicked('prev')
                        decreaseMonth()
                    }}
                    disabled={prevMonthButtonDisabled}
                    aria-label={formatMessage({
                        defaultMessage: 'Select previous month',
                        id: 'date_picker.header.buttons.previous',
                    })}
                    className="react-datepicker__navigation react-datepicker__navigation--previous"
                    {...styles?.monthSelectButton}
                >
                    <ChevronLeft
                        color={lastClicked === 'prev' ? 'text.default' : 'text.date-picker-grey'}
                        {...styles?.monthSelectIcon}
                    />
                </Button>

                <Box {...styles?.monthContainer}>{monthLabel}</Box>

                <Button
                    onClick={() => {
                        setLastClicked('next')
                        increaseMonth()
                    }}
                    disabled={nextMonthButtonDisabled}
                    aria-label={formatMessage({
                        defaultMessage: 'Select next month',
                        id: 'date_picker.header.buttons.next',
                    })}
                    className="react-datepicker__navigation react-datepicker__navigation--next"
                    {...styles?.monthSelectButton}
                >
                    <ChevronRight
                        color={lastClicked === 'next' ? 'text.black' : 'text.date-picker-grey'}
                        {...styles?.monthSelectIcon}
                    />
                </Button>
            </Flex>

            <Flex {...styles?.yearsContainer}>
                <YearSelect year={currentYear} years={years} onChange={changeYear} />
            </Flex>
        </Box>
    )
}

DatePickerHeader.propTypes = {
    date: PropTypes.object,
    changeYear: PropTypes.func,
    decreaseMonth: PropTypes.func,
    increaseMonth: PropTypes.func,
    prevMonthButtonDisabled: PropTypes.bool,
    nextMonthButtonDisabled: PropTypes.bool,
    locale: PropTypes.string,
}

export default DatePickerHeader
